import { clearTokens } from "../../utils/tokenManager";
import { useState } from "react";
import CompanySwitcher from "../common/CompanySwitcher";
import { useProfileViewModel } from "../../viewmodels/profile/useProfileViewModel";
import { clearTenant } from "../../utils/tenantManager";
/* import { Bell } from "lucide-react"; */
/* import { useNavigate } from "react-router-dom"; */
/* import { useNotification } from "../../context/NotificationContext"; */

interface Props {
  setSidebarOpen: (value: boolean) => void;
}

const Header = ({ setSidebarOpen }: Props) => {
  /* const navigate = useNavigate();
 */
/*   const { unreadCount } = useNotification(); */

  const { user } = useProfileViewModel();

  const [open, setOpen] = useState(false);

  const logout = () => {
    const confirmLogout = window.confirm("Are you sure you want to log out?");

    if (!confirmLogout) return;

    clearTokens();
    clearTenant();

    //  full reload (only once)
    window.location.href = "/login";
  };

  return (
    <header className="flex items-center justify-between border-b px-6 py-3 bg-white">
      {/* LEFT */}
      <div className="flex items-center gap-4">
        <button className="lg:hidden" onClick={() => setSidebarOpen(true)}>
          ☰
        </button>

        {/* COMPANY SWITCHER */}
        <CompanySwitcher />
      </div>

      {/* RIGHT */}
      <div className="flex items-center gap-4">
        {/* Notification */}
        {/* <button
          onClick={() => navigate("/requests")}
          className="relative p-2 rounded-full hover:bg-slate-100 transition"
          title="Contact Requests"
        >
          <Bell size={22} />

          {unreadCount > 0 && (
            <span
              className="absolute -top-1 -right-1 min-w-[18px] h-[18px]
                   px-1 rounded-full bg-red-500 text-white
                   text-[11px] font-semibold flex items-center justify-center"
            >
              {unreadCount > 99 ? "99+" : unreadCount}
            </span>
          )}
        </button> */}

        <div className="relative">
          <button
            onClick={() => setOpen(!open)}
            className="flex items-center gap-2 border px-3 py-1 rounded"
          >
            👤 {user ? `${user.firstName} ${user.lastName}` : "Loading..."}
          </button>

          {open && (
            <div className="absolute right-0 mt-2 w-40 bg-white shadow rounded z-50">
              <button
                onClick={logout}
                className="w-full text-left px-3 py-2 hover:bg-gray-100 text-red-600"
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
